export default "__VITE_ASSET__paCDx$6D__"